var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-list',{staticClass:"container",attrs:{"itemLayout":"horizontal","grid":{ gutter: 10, xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}},[_c('a-spin',{attrs:{"size":"large"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }